module.exports = __webpack_public_path__ + "images/hero-4.jpg?c9e1f";